import * as React from "react";
import { cn } from "@/lib/utils";

export function SectionCard({ id, title, subtitle, children, className }) {
    return (
        <section id={id} className={cn("scroll-mt-24 animate-fade-up", className)}>
            <div className="mb-5">
                <h2 className="text-2xl lg:text-3xl font-bold tracking-tight text-bio-text">
                    {title}
                </h2>
                {subtitle && (
                    <p className="text-sm text-bio-text-secondary mt-1 max-w-2xl">{subtitle}</p>
                )}
            </div>
            <div className="bg-white border border-bio-border-subtle rounded-bio-card shadow-bio-sm p-6 md:p-8">
                {children}
            </div>
        </section>
    );
}

export function SpecRow({ label, children }) {
    return (
        <div className="flex flex-col gap-1">
            <span className="text-xs font-semibold uppercase tracking-wider text-bio-text-secondary">
                {label}
            </span>
            <div className="flex flex-wrap items-center gap-3">{children}</div>
        </div>
    );
}
